import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { ContentPanel } from "@/components/admin/ContentPanel";
import { Inbox } from "@/components/admin/Inbox";

export default function Admin() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("content");

  useEffect(() => {
    document.title = "Admin | Violet Psychotherapy";
    let meta = document.head.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex");
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    return () => meta.remove();
  }, []);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  if (user === null) return <div className="min-h-screen bg-[#FAF8F4]" />;
  if (user === false) return <AdminLogin onLogin={setUser} />;

  return (
    <div className="min-h-screen bg-[#FAF8F4]" data-testid="admin-dashboard">
      <header className="border-b border-[#B9A9D8]/40 bg-white">
        <div className="wrap flex h-20 items-center justify-between gap-4">
          <Link to="/" data-testid="admin-view-site"><img src="/logo.webp" alt="Violet Psychotherapy" className="h-12 w-auto" /></Link>
          <div className="flex items-center gap-4 text-sm">
            <span className="hidden text-[#6B7280] sm:inline">{user.email}</span>
            <button onClick={logout} className="btn-ghost !px-4 !py-2 text-sm" data-testid="admin-logout-button">Sign out</button>
          </div>
        </div>
      </header>
      <div className="wrap py-10">
        <h1 className="text-4xl text-[#22304A]">Site admin</h1>
        <p className="mt-2 text-[#6B7280]">Edit your contact email, Calendly links, fees, policies and page copy. Appointments are managed in Calendly.</p>
        <div role="tablist" className="mt-8 flex gap-2">
          {[["content", "Content & settings"], ["inbox", "Inbox"]].map(([id, label]) => (
            <button key={id} role="tab" aria-selected={tab === id} onClick={() => setTab(id)} className={`rounded-full px-5 py-2.5 text-sm font-medium transition-colors duration-300 ${tab === id ? "bg-[#22304A] text-white" : "border border-[#B9A9D8]/60 text-[#22304A] hover:bg-[#B9A9D8]/20"}`} data-testid={`admin-tab-${id}`}>
              {label}
            </button>
          ))}
        </div>
        <div className="mt-8">{tab === "content" ? <ContentPanel /> : <Inbox />}</div>
      </div>
    </div>
  );
}
